import { Pressable } from 'components/Pressable';
import * as React from 'react';
import { Platform, View } from 'react-native';
import { useDispatch } from 'react-redux';
import { RESET_DEV } from 'store/actions';
import * as Updates from 'expo-updates';
import { ICONS, Icon } from 'components/Icon';
import { theme } from 'lib/theme';

const SYNC_CIRCLE_SIZE = 68;
const CIRCLE_SIZE = 32;
const ICON_SIZE = CIRCLE_SIZE / 2;

export const DevIndicator = (): React.ReactElement | null => {
  const dispatch = useDispatch();
  if (!__DEV__) {
    return null;
  }
  return (
    <View style={{ width: SYNC_CIRCLE_SIZE }}>
      <Pressable
        onPress={() => {
          dispatch(RESET_DEV());
          setTimeout(() => {
            if (Platform.OS === 'web') {
              window.location.reload();
            } else {
              Updates.reloadAsync();
            }
          }, 1000);
        }}
        style={{
          backgroundColor: theme.colors.black30,
          boxShadow: [
            {
              offsetX: 0,
              offsetY: 0,
              color: theme.colors.black30,
              blurRadius: 5,
            },
          ],
          alignItems: 'center',
          elevation: 99,
          flexDirection: 'column',
          justifyContent: 'center',
          alignSelf: 'center',
          zIndex: 99999,
          shadowRadius: 0,
          borderRadius: CIRCLE_SIZE,
          height: CIRCLE_SIZE,
          width: CIRCLE_SIZE,
        }}
      >
        <Icon
          source={ICONS.WandMagicSparklesLight}
          size={ICON_SIZE}
          color={theme.colors.white}
        />
      </Pressable>
    </View>
  );
};
